import type { ReactNode } from 'react'

import { FormLabel } from '@monthio/design-system'
import { TOKENS } from '@monthio/design-system/tokens'
import { Section } from '@monthio/react-components'
import { useTranslation } from 'react-i18next'
import { styled } from 'styled-components'

interface InputGroupProps {
	title?: string
	children: ReactNode
	spacing?: 'xs' | 's' | 'm' | 'l' | 'xl'
}
export const InputGroup = ({
	title,
	children,
	spacing = 'xl',
}: InputGroupProps) => {
	const { t } = useTranslation()
	return (
		<InputGroupWrapper>
			{title ? (
				<FormLabel
					label={title}
					weight="strong"
					requiredText={t('required')}
					isRequired
				/>
			) : null}
			<InputList $spacing={spacing}>{children}</InputList>
		</InputGroupWrapper>
	)
}

const InputGroupWrapper = styled.div.attrs({
	role: 'group',
})`
	display: flex;
	flex-direction: column;
	gap: ${TOKENS.space.xs};
`

const InputList = styled.div<{ $spacing: 'xs' | 's' | 'm' | 'l' | 'xl' }>`
	display: flex;
	flex-direction: column;
	gap: ${({ $spacing }) => TOKENS.space[$spacing]};
`

export const InputSection = ({ children }: { children: ReactNode }) => {
	return (
		<Section>
			<InputList $spacing="xl">{children}</InputList>
		</Section>
	)
}
